import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { NoFulfilmentOptions } from '@modules/product/fulfilmentOptions';
import { NoProductOptions } from '@modules/product/productOptions';
import { getProductPrice, isNumeric } from 'helpers/productPrice/productPrices';
import { getQueryParameter } from 'helpers/urls/url';
import { getSanitisedHtml } from '../utilities/utilities';
const hasDiscount = (promotion) => isNumeric(promotion?.discountedPrice);
function applyDiscount(price, promotion) {
    if (hasDiscount(promotion)) {
        return { ...price, price: promotion.discountedPrice };
    }
    return price;
}
const matchesQueryParam = (promotion) => getQueryParameter('promoCode') === promotion.promoCode;
function getAppliedPromo(promotions) {
    if (promotions && promotions.length > 0) {
        if (promotions.length > 1) {
            return promotions.find(matchesQueryParam) ?? promotions[0];
        }
        return promotions[0];
    }
    return undefined;
}
function getPromotion(productPrices, country, billingPeriod, fulfilmentOption = NoFulfilmentOptions, productOption = NoProductOptions) {
    /*
  getProductPrice can raise an Error if not available (ie Storybook)
  this try/catch wrapper ensures its returned as undefined as specified,
  getProductPrice (used throughout) safer to remain un-changed
  */
    try {
        return getAppliedPromo(getProductPrice(productPrices, country, billingPeriod, fulfilmentOption, productOption).promotions);
    }
    catch (error) {
        return undefined;
    }
}
function getPromotionCopy(promotionCopy, isGift) {
    if (!promotionCopy) {
        return {};
    }
    const msgFirstPerson = isGift ? 'their' : 'your';
    return {
        title: promotionCopy.title ?? `Open up ${msgFirstPerson} world view`,
        description: getSanitisedHtml(promotionCopy.description ?? ''),
        roundel: getSanitisedHtml(promotionCopy.roundel ?? ''),
    };
}
function promotionHTML(html, { css = '', tag = 'span' } = {}) {
    if (!html) {
        return null;
    }
    const TagName = tag;
    return (_jsx(TagName, { css: css, dangerouslySetInnerHTML: {
            __html: html,
        } }));
}
function finalPrice(productPrices, country, billingPeriod, fulfilmentOption = NoFulfilmentOptions, productOption = NoProductOptions) {
    return applyDiscount(getProductPrice(productPrices, country, billingPeriod, fulfilmentOption, productOption), getPromotion(productPrices, country, billingPeriod, fulfilmentOption, productOption));
}
export { getPromotion, getAppliedPromo, applyDiscount, hasDiscount, getPromotionCopy, promotionHTML, finalPrice, };
